<template>
	<div class="container">
		<div class="url">
		<!-- 	<p><a href="https://kdocs.cn/l/cj9LHJHDCUws[金山文档] 五域创客说明书.docx" target="_blank">说明文档</a></p>
			<p><a href="https://kdocs.cn/l/crSmWQtn3YhC[金山文档] 五域创客系统更新日志.docx">更新日志</a></p> -->
			 <iframe src="https://kdocs.cn/l/cj9LHJHDCUws[金山文档] 五域创客说明书.docx" width="100%" height="100%" id="iframe"></iframe> 
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				
			}
		},
		methods:{
			sugger(){
				window.open= 'https://kdocs.cn/l/cj9LHJHDCUws[金山文档] 五域创客说明书.docx'
			},
			newDaily(){
				window.location.href ='https://kdocs.cn/l/crSmWQtn3YhC[金山文档] 五域创客系统更新日志.docx'
			},
		}
	}
</script>

<style scoped lang="scss">
	.container{
		background-color: #fff;
		width:100%;
		height:100%;
		padding:5px;
	}
	.url{
		height: 100%;
		p{
			display: inline-block;
			margin:0 10px;
		}
		p:hover{
			cursor: pointer;
		}
		a{
			color:#000;
			text-decoration: none;
		}
	}
</style>
